import { render, staticRenderFns } from "./IconLinkTile.vue?vue&type=template&id=4e0588af&scoped=true&"
import script from "./IconLinkTile.vue?vue&type=script&lang=js&"
export * from "./IconLinkTile.vue?vue&type=script&lang=js&"
import style0 from "./IconLinkTile.vue?vue&type=style&index=0&id=4e0588af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0588af",
  null
  
)

export default component.exports